export default "__VITE_ASSET__nQcJ6ygR__"